const base = '';

async function req(path, opts = {}) {
  const res = await fetch(base + path, {
    headers: { 'Content-Type': 'application/json', ...(opts.headers || {}) },
    ...opts,
  });
  if (!res.ok) {
    const err = new Error(`http_${res.status}`);
    err.status = res.status;
    try { err.body = await res.json(); } catch {}
    throw err;
  }
  return res.json();
}

export const api = {
  getTrip: (token) => req(`/api/trip/${token}`),
  start: (token, fix) => req(`/api/trip/${token}/start`, { method: 'POST', body: JSON.stringify(fix) }),
  sendPings: (token, pings) => req(`/api/trip/${token}/pings`, { method: 'POST', body: JSON.stringify({ pings }) }),
  heartbeat: (token) => req(`/api/trip/${token}/heartbeat`, { method: 'POST', body: JSON.stringify({ captured_at: Date.now() }) }),
  end: (token, fix) => req(`/api/trip/${token}/end`, { method: 'POST', body: JSON.stringify(fix) }),
};
